var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPaymentmethods(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5807 10.5811C15.1416 10.5811 13.1621 12.5606 13.1621 14.9997C13.1621 17.4387 15.1416 19.4183 17.5807 19.4183C20.0198 19.4183 21.9993 17.4387 21.9993 14.9997C21.9993 12.5606 20.0198 10.5811 17.5807 10.5811ZM15.7714 15.9578L16.7016 16.888C16.843 17.0294 17.0365 17.1029 17.2356 17.0918C17.4337 17.0797 17.6189 16.9848 17.7416 16.8285L19.523 14.5829C19.7621 14.2806 19.7109 13.8415 19.4096 13.6025C19.1082 13.3634 18.6682 13.4136 18.4291 13.7159L17.1351 15.3485L16.7584 14.9718C16.4858 14.6992 16.044 14.6992 15.7714 14.9718C15.4998 15.2434 15.4998 15.6862 15.7714 15.9578Z",
    fill: "#7F7F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3981 10.1163H2V15.9302C2 16.6084 2.26977 17.2595 2.74884 17.7395C3.22884 18.2186 3.88 18.4884 4.55814 18.4884H13.5274C12.7209 17.5516 12.2326 16.3321 12.2326 15C12.2326 12.8251 13.533 10.9526 15.3981 10.1163ZM8.28 14.3023H5.48837C5.10326 14.3023 4.7907 14.6149 4.7907 15C4.7907 15.3851 5.10326 15.6977 5.48837 15.6977H8.28C8.66512 15.6977 8.97767 15.3851 8.97767 15C8.97767 14.6149 8.66512 14.3023 8.28 14.3023ZM2 8.72093H20.1395V7.55814C20.1395 6.88 19.8698 6.22884 19.3907 5.74884C18.9107 5.26977 18.2595 5 17.5814 5C14.36 5 7.77953 5 4.55814 5C3.88 5 3.22884 5.26977 2.74884 5.74884C2.26977 6.22884 2 6.88 2 7.55814V8.72093Z",
    fill: "#7F7F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaymentmethods);
export default __webpack_public_path__ + "static/media/icon_paymentmethods.b9e898b9155e41cc529413fcde1f0e92.svg";
export { ForwardRef as ReactComponent };